import { render, staticRenderFns } from "./dashboard_cliente.vue?vue&type=template&id=142be566&scoped=true"
import script from "./dashboard_cliente.vue?vue&type=script&lang=js"
export * from "./dashboard_cliente.vue?vue&type=script&lang=js"
import style0 from "./dashboard_cliente.vue?vue&type=style&index=0&id=142be566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142be566",
  null
  
)

export default component.exports